/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { useState } from 'react';

import { Typography } from '../../typography';
import { TimeZonePicker } from '../TimeZonePicker';

export const TimeZonePickerBothMode = () => {
  const [selectedTimezone, setSelectedTimezone] =
    useState<string>('America/New_York');

  return (
    <div style={{ maxWidth: '400px', padding: '20px' }}>
      <Typography variant="title-4" style={{ marginBottom: '16px' }}>
        Both Mode - UTC and City-Based Timezones
      </Typography>
      <Typography variant="body-medium" style={{ marginBottom: '24px' }}>
        This mode displays both UTC offsets and city-based timezones in separate
        sections within the dropdown. Perfect for users who need flexibility in
        choosing between precise UTC offsets or familiar city names.
      </Typography>

      <TimeZonePicker
        label="Select Timezone"
        mode="both"
        value={selectedTimezone}
        onChange={(tz) => {
          setSelectedTimezone(tz);
        }}
        htmlAttributes={{ id: 'time-zone-input' }}
      />

      <div
        style={{
          backgroundColor: '#f5f5f5',
          borderRadius: '4px',
          marginTop: '24px',
          padding: '16px',
        }}
      >
        <Typography
          variant="body-small"
          style={{ fontWeight: 600, marginBottom: '8px' }}
        >
          Selected Timezone:
        </Typography>
        <Typography variant="body-medium">
          {selectedTimezone || 'None'}
        </Typography>
      </div>

      <div style={{ marginTop: '16px' }}>
        <Typography variant="body-small" style={{ color: '#666' }}>
          <strong>Features:</strong>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li>
              Two separate sections: &quot;UTC Offsets&quot; and
              &quot;City-Based Timezones&quot;
            </li>
            <li>Search across both sections simultaneously</li>
            <li>Custom UTC input support (e.g., UTC+5:30)</li>
            <li>All standard UTC offsets from UTC-12 to UTC+14</li>
            <li>All IANA timezone identifiers with city names</li>
          </ul>
        </Typography>
      </div>
    </div>
  );
};

export default TimeZonePickerBothMode;
